import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  moderationCount: { offers: 0, projects: 0, events: 0, vendors: 0, total: 0 },
  lastModeration: new Date().getTime()
};

const moderationCountSlice = createSlice({
  name: "moderationCountValues",
  initialState,
  reducers: {
    update(state, action) {
      state.moderationCount = action.payload;
    },
    modified(state,action){
      state.lastModeration = action.payload;
    }
  },
});

export const { update,modified } = moderationCountSlice.actions;
export default moderationCountSlice.reducer;
